export const SET_COMMAND_LIST = "SET_COMMAND_LIST"

export const setCommandList = (payload) => async (dispatch) => {
    dispatch({
        type: SET_COMMAND_LIST,
        payload

    })
}